import styled from 'styled-components'

export const ReportsAvailableContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
